//Modals
export const TASKDETAIL_MODAL_TOGGLE = "TASKDETAIL_MODAL_TOGGLE";

//User Auth
export const SIGN_UP = "SIGN_UP";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const MODIFY_NAME = "MODIFY_NAME";

//Snackbar
export const SNACK_OPEN = "SNACK_OPEN";
export const SNACK_CLOSE = "SNACK_CLOSE";

//Error
export const APP_ERROR = "APP_ERROR";
export const APP_ERROR_CLEAR = "APP_ERROR_CLEAR";

//Env
export const FETCH_ENV = "FETCH_ENV";

//App Settings
export const ADJUST_TEXT_SIZE = "ADJUST_TEXT_SIZE";
export const CHANGE_LANG = "CHANGE_LANG";
export const UPDATE_SETTINGS = "UPDATE_SETTINGS";

//Client Data
export const SAVE_CLIENT_DATA = "SAVE_CLIENT_DATA"; 